import { render } from "./PriceHistoryChart.vue?vue&type=template&id=24353a54"
import script from "./PriceHistoryChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceHistoryChart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/PriceHistoryChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24353a54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24353a54', __exports__)) {
    api.reload('24353a54', __exports__)
  }
  
  module.hot.accept("./PriceHistoryChart.vue?vue&type=template&id=24353a54", () => {
    api.rerender('24353a54', render)
  })

}


export default __exports__